var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25378 20.625C5.85447 20.625 5.51506 20.4852 5.23555 20.2057C4.95603 19.9262 4.81628 19.5868 4.81628 19.1875V5.53125H3.83398V4.09375H8.33815V3.375H14.6632V4.09375H19.1673V5.53125H18.185V19.1875C18.185 19.5708 18.0413 19.9062 17.7538 20.1937C17.4663 20.4812 17.1309 20.625 16.7475 20.625H6.25378ZM16.7475 5.53125H6.25378V19.1875H16.7475V5.53125ZM8.79336 17.1271H10.2309V7.56771H8.79336V17.1271ZM12.7704 17.1271H14.2079V7.56771H12.7704V17.1271ZM6.25378 5.53125V19.1875V5.53125Z",
    fill: "#5F6369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.23242f4a0bd4c50176b5349e4569465f.svg";
export { ForwardRef as ReactComponent };